module.exports = __webpack_public_path__ + "img/pp-tablet.a6b9e463.jpg";